module.exports = __webpack_public_path__ + "img/sun protection(7).9984f3a7.jpg";